import React from "react";

function FilterButton({ onClick }) {
    return (
        <div className="filter-button-wrapper" onClick={onClick}></div>
    )
}

export default FilterButton;